import {
  Box,
  Button,
  CardContent,
  CardHeader,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { AppRootState } from '../../app/store';
import { checkAutoLogin } from '../Login/auth-reducer';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { setCurrentLocation } from '../../app/cookies';
import { AccountLocationStateType } from './AccountItem';
import { UsersList } from '../Users/UsersList';
import { AlertDelete } from '../common/AlertDeleteAccount';
import { AccountType, deleteAccountTC, getAccountTC, updateAccountTC } from './accounts-reducer';


export const AccountData = () => {
  const location = useLocation()
  const state = location.state as AccountLocationStateType
  const accountId = state.accountId
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const navigate = useNavigate()
  let account = {} as AccountType
  const accounts = useSelector<AppRootState, Array<AccountType>>(state => state.accounts.accounts)
  let accountFormState = accounts.find(acc => acc.id === accountId)

  if(accountFormState) {
    account = accountFormState
  }
  
  const [values, setValues] = useState({ ...account })
  const [checkbox, setCheckbox] = useState(account.isActive)
  let stateLabel
  checkbox ? stateLabel = 'Active' : stateLabel = ''
  const [label, setLabel] = useState(stateLabel)
  const dispatch = useDispatch()

  useEffect(() => {
    let token = checkAutoLogin(dispatch, true)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/accountsList`)
      }
    }
    setCurrentLocation(`\\ Accounts \\ ${account.name}`)
    dispatch(getAccountTC({id: accountId}))
  }, [isLoggedIn, account.users]);

  let reqBody = {
    ...values,
    isActive: checkbox,
  }

  const updateAccountData = () => {
    console.log('request BODY', reqBody)
    dispatch(updateAccountTC({account: reqBody}))
    navigate(`/accountsList/`)
  }

  let isSaveButtonDisabled: boolean
  account.description === values.description && account.name === values.name && account.email === values.email && account.isActive === reqBody.isActive
    ? isSaveButtonDisabled = true
    : isSaveButtonDisabled = false

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckbox(event.target.checked)
    event.target.checked ? setLabel('Active') : setLabel('')
  }
  
  async function removeAccount() {
    await dispatch(deleteAccountTC({account}))
     navigate(`/accountsList/`)
  }
  
  return (
    <>
      <Container >
        <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
          <Grid item xl={8} md={8} xs={6} style={{ paddingTop: '30px' }}>
            {/* <div className='addItemButton' style={{ padding: '5px', display: 'inline-flex', alignItems: 'center', }} onClick={(e) => navigate(`/accountsList/`)} >
              <KeyboardReturnIcon fontSize='medium' style={{ color: 'grey' }} />
              <span>Back to Accounts list</span>
            </div> */}
            <Button onClick={(e) => navigate(`/accountsList/`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Back to Accounts list
          </Button>

          </Grid>
          <Grid item xl={2} md={2} xs={3}>
            <Button style={{ float: 'right' }}
              color="info"
              variant="contained"
              onClick={updateAccountData}
              disabled={isSaveButtonDisabled}
            >Save
            </Button>
          </Grid>
          <Grid item xl={2} md={2} xs={3}>
            <AlertDelete remove={removeAccount} deleteButtonText='delete account' name={`${account.name}`} />
          </Grid>
        </Grid>
        <Box sx={{ pt: 3 }}>
          {/* <Box sx={{ minWidth: 1050 }}> */}
          <Box >
            <form
              autoComplete="off"
              noValidate
            >
              <CardHeader
                title={`Account Information: `}
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="userName"
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={account.name}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      onChange={handleChange}
                      //disabled={isAdmin}
                      required
                      value={values.email}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      required
                      value={values.description}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid alignSelf={'center'}
                    item
                    xl={9}
                    xs={9}><Typography style={{ float: 'right', verticalAlign: 'bottom' }}> Status: </Typography>
                  </Grid>
                  <Grid
                    item
                    xl={3}
                    xs={3}>
                    <div style={{ float: 'right' }}>
                      <FormControlLabel  control={<Switch color='info' name="isActive" checked={checkbox} onChange={handleChangeCheckbox} />} label={label} />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
              <CardHeader
                title={`Users: `}
              />
              <UsersList account={account} />
            </form>
          </Box>
        </Box>
      </Container>
    </>
  );
}
